import { withSitecoreContext, Image } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react';

class ObjBrandEvent extends Component {
	render() {
        const { scDatas } = this.props.fields.data;

		return (
            <div className="obj_brand-event">
                {scDatas && <>
                    {scDatas.imageBackgroundMobile?.jss.value.src && <>
                        {/* Banner Hero */}
                        <div className="ctn_banner-hero">
                            <div className="obj_image">
                                {scDatas.linkBackground?.jss.value.href!=="" ? 
                                    <a href={scDatas.linkBackground.jss.value.href}>
                                        <picture className="ctn_image">
                                            <source media="(max-width:767px)" srcSet={scDatas.imageBackgroundMobile.jss.value.src} />
                                            <img alt="" src=""/>
                                        </picture>
                                    </a>
                                :
                                    <>
                                        <picture className="ctn_image">
                                            <source media="(max-width:767px)" srcSet={scDatas.imageBackgroundMobile.jss.value.src} />
                                            <img alt="" src=""/>
                                        </picture>
                                    </>
                                }
                            </div>
                        </div>
                    </>}

                    {scDatas.imageBackground?.jss.value.src && <>
                        {/* Background Image */}
                        <div className="ctn_background">
                            <div className="obj_image">
                                {scDatas.linkBackground?.jss.value.href!=="" ? 
                                    <a href={scDatas.linkBackground.jss.value.href}>
                                        <picture className="ctn_image">
                                            <Image field={scDatas.imageBackground.jss}></Image>
                                        </picture>
                                    </a>
                                :
                                    <>
                                        <picture className="ctn_image">
                                            <Image field={scDatas.imageBackground.jss}></Image>
                                        </picture>
                                    </>
                                }
                            </div>
                        </div>
                    </>}
                </>}
            </div>
)
	}
}

export default withTranslation()(withSitecoreContext()(ObjBrandEvent));